import { authRequest } from './utils';


/**
 * fetchTaskById :: String -> Promise Error Object
 */
export const fetchTaskById = taskId => authRequest({
  method: 'GET',
  url: `/tasks/${taskId}`,
})
  .then(({ data }) => data);

/**
 * fetchTasks :: Object -> Promise Error Object
 */
export const fetchTasks = ({
  page = 1,
  assignee,
  cancelToken,
  polling,
}) => authRequest({
  method: 'GET',
  url: '/tasks',
  cancelToken,
  params: {
    page,
    assignee,
    ...(polling && { polling }),
  },
})
  .then(({ data, responseTime }) => ({ data, responseTime }));

/**
 * fetchOverviewTasks :: Object -> Promise Error Object
 */
export const fetchOverviewTasks = cancelToken =>
  authRequest({
    method: 'GET',
    url: '/tasks/overview',
    cancelToken,
  })
    .then(({ data, responseTime }) => ({ data, responseTime }));

/**
 * fetchCompletedTasks :: Object -> Promise Error Object
 */
export const fetchCompletedTasks = ({
  page = 1,
  start,
  end,
  assignee,
  cancelToken,
  polling,
}) => authRequest({
  method: 'GET',
  url: '/tasks/reports',
  cancelToken,
  params: {
    page,
    start,
    end,
    assignee,
    ...(polling && { polling }),
  },
})
  .then(({ data, responseTime }) => ({ data, responseTime }));

/**
 * createTask :: Object -> Promise Error Object
 */
export const createTask = task =>
  authRequest({
    method: 'POST',
    url: '/tasks',
    data: task,
  })
    .then(({ data }) => data);

/**
 * createMultipleRequestTasks :: (String, Object) -> Promise Error Object
 */
export const createMultipleRequestTasks = (requestId, data) =>
  authRequest({
    method: 'POST',
    url: '/tasks/multiple',
    data: { requestId, tasksData: data },
  })
    .then(res => res.data);

/**
 * updateTask :: (String, Object) -> Promise Error Object
 */
export const updateTask = (taskId, modifier) =>
  authRequest({
    method: 'PATCH',
    url: `/tasks/${taskId}`,
    data: modifier,
  })
    .then(({ data }) => data);

/**
 * updateManyTasks :: [String] -> Promise Error Object
 */
export const updateManyTasks = tasksIds =>
  authRequest({
    method: 'PATCH',
    url: '/tasks/',
    data: tasksIds,
  })
    .then(({ data }) => data);

/**
 * deleteTask :: String -> Promise Error Object
 */
export const deleteTask = taskId =>
  authRequest({
    method: 'DELETE',
    url: `/tasks/${taskId}`,
  })
    .then(({ data }) => data);



// WEBPACK FOOTER //
// ./src/api/apiko-api/tasks.js